export const RedCrossIcon = ({
  strokeColor = "var(--color-red)",
  ...props
}: any) => (
  <svg {...props} width="15" height="16" viewBox="0 0 15 16" fill="none">
    <g id="Icons All">
      <path
        id="Vector"
        d="M7.5 14.25C9.22587 14.25 10.7884 13.5504 11.9194 12.4194C13.0504 11.2884 13.75 9.72587 13.75 8C13.75 6.27413 13.0504 4.71162 11.9194 3.58058C10.7884 2.44956 9.22587 1.75 7.5 1.75C5.77413 1.75 4.21162 2.44956 3.08058 3.58058C1.94956 4.71162 1.25 6.27413 1.25 8C1.25 9.72587 1.94956 11.2884 3.08058 12.4194C4.21162 13.5504 5.77413 14.25 7.5 14.25Z"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <line
        id="Line 184"
        x1="11.5606"
        y1="3.49827"
        x2="3.56056"
        y2="12.4983"
        stroke={strokeColor}
        strokeWidth="1.5"
      />
    </g>
  </svg>
);
